import React, { PropsWithChildren } from "react";
import useTextAlignment from "../../../hooks/useTextAlignment";
import useTextDirection from "../../../hooks/useTextDirection";

type TextDirAlignerProps = {
  className?: string;
  variant?: "p" | "h1" | "h2" | "h3" | "h4" | "h5" | "h6" | "span";
};
const TextDirAligner = ({
  className,
  variant = "p",
  children,
}: PropsWithChildren<TextDirAlignerProps>): JSX.Element => {
  const text = children as string;
  const dir = useTextDirection(text);
  const { className: textAlign } = useTextAlignment(text);
  const element = React.createElement(variant, {
    children,
    dir,
    className: `${textAlign} ${className}`,
  });
  return element;
};

export default TextDirAligner;
